/**
 * 属性（ジャンル）の色と呼び名の正本。精霊・図鑑・地図はここを読む。
 * 管理画面（local-ui）も写しで読むので、import は書かないこと（書くなら相対パスだけ）。
 * 色は地図の暗い地で見分けやすい明るさに揃えてある。
 */

export type GenreKey =
  | "fantasy"
  | "sf"
  | "horror"
  | "mystery"
  | "romance"
  | "comedy"
  | "literary"
  | "adventure"
  | "action";

export const GENRES: { key: GenreKey; label: string; color: string }[] = [
  { key: "fantasy",   label: "ファンタジー", color: "#a78bfa" },
  { key: "sf",        label: "SF",           color: "#06b6d4" },
  { key: "horror",    label: "ホラー",       color: "#f87171" },
  { key: "mystery",   label: "ミステリー",   color: "#60a5fa" },
  { key: "romance",   label: "ロマンス",     color: "#f472b6" },
  { key: "comedy",    label: "コメディ",     color: "#fbbf24" },
  { key: "literary",  label: "文芸",         color: "#a16207" },
  { key: "adventure", label: "冒険",         color: "#34d399" },
  { key: "action",    label: "アクション",   color: "#f97316" },
];

export const GENRE_LABELS = Object.fromEntries(GENRES.map((g) => [g.key, g.label])) as Record<GenreKey, string>;

export const GENRE_COLORS = Object.fromEntries(GENRES.map((g) => [g.key, g.color])) as Record<GenreKey, string>;

/** rgba() に入れる "r, g, b" の形 */
export const GENRE_RGB = Object.fromEntries(
  GENRES.map((g) => {
    const n = parseInt(g.color.slice(1), 16);
    return [g.key, `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`];
  }),
) as Record<GenreKey, string>;
